import { Video } from "./video";
import { VideoListItem } from "./videoListItem";

export class VideoBundle {
    videoListItem: VideoListItem;
    video: Video
}